import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Typography, Box } from '@material-ui/core';
import { ReactComponent as BalanceSVG } from '../../../event-details/assets/balance.svg';
import { ReactComponent as SessionSVG } from '../../../event-details/assets/session.svg';
import { ReactComponent as LanguageSVG } from '../../../event-details/assets/language.svg';
import { ReactComponent as SeatSVG } from '../../../event-details/assets/seats.svg';
import { ReactComponent as BalanceDisabledSVG } from '../../../event-details/assets/balance-disabled.svg';
import { useStyles } from '../../../event-details/styles';
import { useAppConfiguration } from '../../../../shared/hook';
import { colors } from '../../../../../style/colors';
import { IconsListItemProps } from '../../../event-details';
import { EventType } from '../../../../../types';

const IconsListItem: FC<IconsListItemProps> = ({
  icon,
  label,
  isDisabled,
  wrapWidth,
}) => {
  const classes = useStyles({ wrapWidth });

  return (
    <Box className={classes.iconItemContainer}>
      <Typography
        component="span"
        variant="body1"
        className={classes.iconWrapper}
      >
        {icon}
      </Typography>
      <Typography
        component="div"
        variant="body1"
        className={classes.labelWrapper}
        style={{
          fontWeight: 700,
          color: isDisabled ? colors.darkGray : colors.darkestGray,
        }}
      >
        {label}
      </Typography>
    </Box>
  );
};

const EventDetailsDrawer = (props: { offering: any }) => {
  const { offering } = props;
  const classes = useStyles({});
  const [t, i18n] = useTranslation();
  const { withUnlimitedCredits } = useAppConfiguration();

  const offeringLanguage = new Intl.DisplayNames([i18n.language], {
    type: 'language',
  });

  const sessionLabel = t('v2.global.label_session', {
    count: offering.sessions.length,
  });

  const seatsLeft = offering.maxParticipants - offering.numberOfBookings;
  const seats =
    offering.type === EventType.WEBINAR
      ? t('v2.global.label_eventSeatsUnlimited')
      : `${seatsLeft} ${t('v2.global.label_eventSeatsLeft')}`;

  return (
    <>
      {!withUnlimitedCredits ? (
        <Box className={classes.listContainer}>
          <Box className={classes.iconsContainer}>
            <IconsListItem
              icon={<LanguageSVG />}
              label={`${
                offering.language && offeringLanguage.of(offering.language)
              }`}
            />
          </Box>
          <Box className={classes.iconsContainer}>
            <IconsListItem
              icon={
                offering.price > 0 ? <BalanceSVG /> : <BalanceDisabledSVG />
              }
              label={t('v2.global.label_credits', { count: offering.price })}
              isDisabled={offering.price === 0}
            />
          </Box>
          <Box className={classes.iconsContainer}>
            <IconsListItem icon={<SessionSVG />} label={sessionLabel} />
          </Box>

          <Box className={classes.iconsContainer}>
            <IconsListItem icon={<SeatSVG />} label={seats} wrapWidth={100} />
          </Box>
        </Box>
      ) : (
        <Box className={classes.listUnlimitedContainer}>
          <IconsListItem
            icon={<LanguageSVG />}
            label={`${
              offering.language && offeringLanguage.of(offering.language)
            }`}
          />
          <IconsListItem icon={<SessionSVG />} label={sessionLabel} />
        </Box>
      )}
    </>
  );
};

export default EventDetailsDrawer;
